import { Form } from 'antd';
import CustomerTextInput from '../../inputs/customerTextInput/CustomerTextInput';
import CustomerDateInput from '../../inputs/customerDateInput/CustomerDateInput';
import useTranslation from '../../../hooks/translation/useTranslation';
import DefaultButton from '../../components/buttons/defaultButton/DefaultButton';

function EditSavedPassengerForm({
  handleSubmit,
  form,
}) {
  const { trans } = useTranslation();
  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={handleSubmit}
      className="max-w-[760px] flex flex-col gap-4 lg:block"
    >
      <div className="flex flex-col lg:flex-row gap-4">
        <CustomerTextInput
          className="flex-1"
          label={trans('first_name')}
          name="first_name"
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
        />
        <CustomerTextInput
          className="flex-1"
          label={trans('last_name')}
          name="last_name"
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
        />
      </div>
      <div className="flex flex-col lg:flex-row gap-4">
        <CustomerTextInput
          className="flex-1"
          label={trans('document_number')}
          name="id_number"
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
        />
        <CustomerDateInput
          name="birth_date"
          className="flex-1 flex justify-center"
          label={trans('birth_date')}
        />
      </div>
      <div className="flex flex-col lg:flex-row gap-4">
        <div className="basis-1/2">
          <CustomerTextInput
            className="hidden"
            name="id"
            rules={[{
              required: true,
              message: trans('input_necessary'),
            }]}
          />
        </div>
        <DefaultButton type="submit" className="basis-1/2">
          {trans('submit')}
        </DefaultButton>
      </div>
    </Form>
  );
}
export default EditSavedPassengerForm;
